import { ReactElement } from 'react';
import styled from 'styled-components';

import { ConditionalLink, Flex, Icons } from 'components';
import { IconsTypes } from 'components/icons';

interface SidebarButtonProps {
  label: string;
  type: 'internal' | 'external' | 'nolink';
  to: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
  onClick?: () => void;
  icon?: IconsTypes;
  size?: 'large' | 'medium';
  borderRadiusTop?: boolean;
}

const BadgeButtonIcon = styled(Icons)`
  width: 24px;
  color: ${({ theme }) => theme.colors.dark_400};
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
`;

const BadgeLink = styled(ConditionalLink)`
  min-width: 350px;
  display: flex;
  flex-grow: 1;
`;

const BadgeButton = styled('button')`
  height: ${(props: any) => {
    if (props['data-size'] === 'medium') {
      return '40px;';
    }

    return '60px;';
  }};
  position: relative;
  flex-grow: 1;
  padding: 0;
  border: 0;
  text-align: left;
  margin: 0;
  padding: 15px 20px 14px 20px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  color: ${({ theme }) => theme.colors.dark_400};
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  background: ${({ theme }) => theme.colors.primary_400};
  cursor: pointer;

  ${(props: any) => {
    if (props['data-borderradiustop']) {
      return `
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      `;
    }
  }}

  &:hover {
    background: ${({ theme }) => theme.colors.primary_200};

    ${BadgeButtonIcon} {
      color: ${({ theme }) => theme.colors.dark_400};
    }
  }
`;

const SidebarButton = ({
  label,
  type,
  to,
  size = 'large',
  target = '_self',
  onClick,
  icon = 'arrowRight',
  borderRadiusTop = false,
}: SidebarButtonProps): ReactElement => (
  <>
    <BadgeLink to={to} type={type} target={target} component={Flex}>
      <BadgeButton data-size={size} onClick={onClick} data-borderradiustop={borderRadiusTop}>
        {label}
        <BadgeButtonIcon icon={icon} />
      </BadgeButton>
    </BadgeLink>
  </>
);

export default SidebarButton;
